<template>
  <Select
    v-if="catalogSettings?.allowed_langs.length > 1"
    :button-class="buttonClass + ' group'"
    :options="catalogSettings.allowed_langs"
    :value="currentLanguage"
    :chevron-size="chevronSize"
    :fullscreen="!$windowSize.isDesktop"
    @input="changeLanguage"
  >
    <template #title>
      {{ $t('titles.Language') }}
    </template>
    <template #current-option-icon="{}">
      <lucide-icon
        class="text-primary group-hover:text-primary-active me-2"
        icon="Globe"
        :size="$windowSize.isMobile ? 16 : 14"
      />
    </template>
    <template #current-option="{ option }">
      <div v-if="!$windowSize.isMobile" class="mt-0.5 text-xs">
        {{ $t('langs.lang-' + option.name) }}
      </div>
      <div v-else class="mt-0.5 text-sm">
        {{ $t('titles.Language') }}
      </div>
    </template>
    <template #option="{ option }">
      {{ $t('langs.lang-' + option.name) }}
    </template>
  </Select>
</template>
<script>
import Select from '@/components/ui/Select';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LanguageSelect',
  components: {
    Select,
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    chevronSize: {
      type: Number,
      required: false,
      default: 16,
    },
  },
  computed: {
    ...mapGetters(['currentLanguage', 'catalogSettings']),
  },
  methods: {
    ...mapActions(['SET_LANGUAGE']),
    async changeLanguage(lang) {
      const currentRoute = this.$route;
      const params = { ...currentRoute.params };
      params.lang = lang.name;
      this.routerReplace({
        name: currentRoute.name,
        params,
        query: currentRoute.query,
      });

      // this.$push();

      //     await this.LOAD_CATALOG({
      //   firstToken: this.$route.params.firstToken,
      //   secondToken: this.$route.params.secondToken,
      //   lang: this.$route.params.lang,
      // });
    },
  },
};
</script>
